/**
 * Generate a hash from a URL and a salt.
 * This function is not cryptographically secure and is only used to prevent URL tampering.
 * @param decodedUrl The decoded URL to hash.
 * @param salt The salt to use in the hash.
 * @returns The generated hash.
 */
export function generateHashFromUrl(decodedUrl: string, salt: string): string {
    return sdbmHash(`${decodedUrl}:${salt}`).toString();
}

function sdbmHash(str: string) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + (hash << 6) + (hash << 16) - hash;
        hash |= 0; // ensure 32-bit int
    }
    return hash;
}
